import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { Page404Component } from './extrapages/page404/page404.component';
import { DashboardSharedComponent } from './shared/dashboard/dashboard.shared.component';
import { MillDashboardSharedComponent } from './shared/milldashboard/milldashboard.shared.component';
import { LandingPageComponent } from './pages/landingpages/landingpage/landingpage.component';
import appSettings from '../assets/settings/system.settings.json';
import { DownloadComponent } from './shared/download/download';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'download', component: DownloadComponent  },
  { path: 'shared-dashboard', component: DashboardSharedComponent },
  { path: 'shared-milldashboard', component: MillDashboardSharedComponent },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule) },
  { path: '**', component: Page404Component },
  { path: 'landingpage', component: LandingPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
